import { localCache } from '@/utils/cache'

/**
 * 检查菜单结构中是否存在对应的权限层级
 * @param {Array} menu 菜单数组
 * @param {Array} permissionKeys 权限键数组，索引表示深度
 * @returns {boolean} 是否存在匹配的权限层级
 */
export default function checkRunningEnvironment() {
  const obj = localCache.getCache('teamMessage') || {}
  if (obj.ownerType == '1') {
    return 'team'
  } else if (obj.ownerType == '2') {
    return 'company'
  } else {
    return 'person'
  }
}
